import React from "react";
import { useSelector } from "react-redux";
import Konsole from "../../utils/konsole/Konsole";

const Loader = () => {
    const reduxData = useSelector((state: any) => state?.commonData);

    Konsole.log('reduxData', reduxData)

    return <>
        {reduxData?.loader && <div className="fixed inset-0 bg-white bg-opacity-35 flex justify-center items-center z-50 pointer-events-auto">
            <div className="w-12 h-12 border-4 border-t-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
        </div>}

    </>
}

export default Loader;